<div class="modal-body">
  <button type="button" class="btn-close" aria-label="Close" (click)="close()" [disabled]="submitted"></button>

  <!-- Profile -->
  <div class="section-profile" *ngIf="profile">
    <div class="text-center">
      <br/>

      <div>
        <img class="img-responsive img-circle" [src]="profile.user.image ? profile.user.image.filePath : '/images/profile-modal/profile-default.png'" style="width: 180px" alt="User profile picture"/>
      </div>

      <br/>

      <h3>{{ profile.user.firstName }} {{ profile.user.lastName }}</h3>
    </div>
  </div>

  <!-- Send message-->
  <div class="section-message mb-1" *ngIf="currentUser && profile && !isProfileEditable">

    <!-- New message -->
    <form (ngSubmit)="submit()" ngNativeValidate *ngIf="!isMessageSent">
      <div class="input-group mb-3" *ngIf="isMessageRequired">
        <textarea id="message" name="message" [(ngModel)]="message" class="form-control" style="min-height:100px;" placeholder="Type a message..." minlength="1" maxlength="8000" cdkTextareaAutosize [required]="isMessageRequired"></textarea>
      </div>

      <div class="text-center">
        <button class="btn btn-yellow" type="submit" [disabled]="submitted">Send Message</button>
      </div>
    </form>

    <!-- Message sent -->
    <div *ngIf="isMessageSent">
      <div class="text-center">
        <h4 class="color-neon-blue">Message sent!</h4>
        <p><a class="underline" routerLink="/inbox" (click)="close()">View your message inbox</a></p>
      </div>
    </div>

    <br/>
  </div>

  <!-- Profile description -->
  <div class="section-description mb-1" *ngIf="profile && profile.description">
    <h4>
      <span>In a nutshell</span>
      <span *ngIf="isProfileEditable"><button class="btn color-neon-blue ps-2 pe-2" (click)="toggleDescription()">(edit)</button></span>
    </h4>

    <div *ngIf="isToggleDescription">
      <div class="input-group">
      <textarea id="description"
                name="description"
                [(ngModel)]="description"
                class="form-control"
                style="min-height:100px;"
                placeholder="Tell us a bit about yourself ..."
                minlength="1"
                maxlength="1000"
                cdkTextareaAutosize
                [required]="isToggleDescription"
                (blur)="updateDescription()"></textarea>
      </div>
    </div>

    <div *ngIf="!isToggleDescription">
      <p [innerHTML]="profile.description | linkify"></p>
    </div>
  </div>

  <!-- Profile favorite space -->
  <div class="section-favorite-space mb-1" *ngIf="profile && profile.favoriteSpaces">
    <h4>
      <span>Favorite spaces</span>
      <span *ngIf="isProfileEditable"><button class="btn color-neon-blue ps-2 pe-2" (click)="toggleFavoriteSpaces()">(edit)</button></span>
    </h4>

    <div *ngIf="isToggleFavoriteSpaces">
      <div class="input-group">
        <textarea id="favoriteSpaces" name="favoriteSpaces"
                  [(ngModel)]="favoriteSpaces" class="form-control" style="min-height:100px;"
                  placeholder="Your favorite space is ..."
                  minlength="1"
                  maxlength="1000"
                  cdkTextareaAutosize
                  [required]="isToggleFavoriteSpaces"
                  (blur)="updateFavoriteSpaces()"></textarea>
      </div>
    </div>

    <div *ngIf="!isToggleFavoriteSpaces">
      <p [innerHTML]="profile.favoriteSpaces | linkify"></p>
    </div>
  </div>

  <!-- Profile interests -->
  <div class="section-interests mb-1" *ngIf="profile && profile.tags">
    <h4>
      <span>Let's talk about</span>
      <span *ngIf="isProfileEditable"><button class="btn color-neon-blue ps-2 pe-2" (click)="toggleInterests()">(edit)</button></span>
    </h4>

    <div *ngIf="isToggleInterest">
      <p>
        <a (click)="updateInterests(tag)" *ngFor="let tag of tags">
          <span class="tag" [class]="{'active': interestIds.includes(tag._id)}">{{ tag.name }}</span>
        </a>
      </p>
    </div>

    <div *ngIf="!isToggleInterest">
      <p>
        <span class="tag active" *ngFor="let tag of profile.tags">{{ tag.name }}</span>
      </p>
    </div>
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="submitted">Close</button>
</div>
